// @ts-nocheck

const loadItem = (storage) => (key) => {
  try {
    if (storage) {
      return JSON.parse(storage.getItem(key));
    }
  } catch (err) {
    console.warn(err);
  }
  return null;
};

const saveItem = (storage) => (key, data) => {
  if (storage) {
    storage.setItem(key, JSON.stringify(data));
  }
};

const deleteItem = (storage) => (key) => {
  if (storage) {
    storage.removeItem(key);
  }
};

const getStorage = (storageType) => {
  let storage = null;
  try {
    storage = window && window[storageType];
  } catch (err) {
    console.warn(err);
  }
  return {
    load: loadItem(storage),
    save: saveItem(storage),
    delete: deleteItem(storage),
  };
};

export default {
  sessionStorage: getStorage('sessionStorage'),
  localStorage: getStorage('localStorage'),
};
